<template> 
  <div class="container">
    <Sidebar></Sidebar>

    <nav class="nav-extended blue-nav">
      <div class="nav-wrapper">
        <span class="nav-title"> Manage content </span>
        
      </div>
       
      <div class="nav-content">
        <ul class="tabs tabs-transparent">
          <li class="tab"><a class="active" href="/tutorials">Tutorials</a></li>
          <li class="tab">
            <a target="_self" href="/categories">Categories</a>
          </li>
          <li class="tab"><a target="_self" href="/quizzes">Quizzes</a></li>
        </ul>
        
        <button
          class="btn-floating btn-large halfway-fab waves-effect waves-light z-depth-3"
          style="background-color: #27282a"
          v-on:click="createTutorial"
        >
          <!-- <a href="https://dashboard.fyiio.com/#articles" class="z-depth-3 btn-floating btn-large halfway-fab waves-effect waves-light orange"> -->
          <i class="material-icons white-text">add</i>
        </button>
      </div>
      
    </nav>
    <div v-if="showGrandfatheredBanner">
      <h5 class="center">The free plan allows for 10 active tutorials. Please upgrade to a paid plan to publish additional tutorials.<br><br></h5>
    </div>
    
    <div v-if="showFreeBanner">
      <h6 class="center">The free plan allows for tutorials up to 5 minutes in length. Please <a href="/settings#plan">upgrade to the Maker or Team plan to publish longer tutorials</a>.<br><br></h6>
    </div>
    <div v-if="showMakerBanner">
      <h6 class="center">The Maker plan allows for tutorials up to 10 minutes in length. Please <a href="/settings#plan">upgrade to the Team plan to publish longer tutorials</a>.<br><br></h6>
    </div>
    <div v-if="showTeamBanner">
      <h6 class="center">Team Plan.<br><br></h6>
    </div>
    <div v-if="showCompanyBanner">
      <h6 class="center">Company Plan.<br><br></h6>
    </div>
    <div class="progress" v-if="loading">
      <div class="indeterminate"></div>
    </div>
    <div id="tutorials" v-if="!loading">
      <div class="alert alert-danger" v-if="error">
        <p v-if="error" class="error red-text">
          There was an error loading tutorials: {{ error.message }}
        </p>
      </div>

      <div
        v-if="
          !articles ||
          articles.length == 0 ||
          (articles && articles[0].chapters && articles[0].chapters.length == 0)
        "
        class="row"
      >
        <h3 class="collection-header">Welcome to fyiio</h3>
        <ul class="collection s12">
          <li class="collection-item row valign-wrapper">
            <div class="col s11">
              <div>Build your first tutorial</div>
              <span class="author">Click the dark grey circle</span>
            </div>
            <div class="col s1 right-align">
              <i class="material-icons">arrow_upward</i>
            </div>
          </li>
        </ul>
      </div>
      <div class="row">
        <!--
        <div class="col s12">
          <ul class="tabs">
            <li class="tab col s6">
              <a class="active" style="color: blue" href="#allTutorials"
                >All Tutorials</a
              >
            </li>
            <li class="tab col s6">
              <a class="active" style="color: blue" href="#tutorialsByCategory"
                >Tutorials By Category</a
              >
            </li>
          </ul>
        </div>
        -->
        <div id="tutorialsByCategory" style="height: 100%" class="col s12">
          <h3
            class="collection-header"
            v-if="uncategorizedTutorials.length > 0"
          >
            Uncategorized Tutorials
          </h3>
          <div v-if="uncategorizedTutorials.length == 0"></div>
          <div v-else>
            <ul class="collection s12">
              <li
                v-for="(tutorial, index) in uncategorizedTutorials"
                :key="'uncat_' + index"
                class="collection-item row valign-wrapper"
              >
                <div class="col s11">
                  <a
                    class="tutorial-link"
                    v-bind:href="tutorialViewLink(tutorial.id)"
                    target="_blank"
                    >{{ tutorial["title"] }}</a
                  >
                  <ul v-bind:id="'ud_uncat_' + index" class="dropdown-content">
                    <li>
                      <a v-bind:href="'/tutorials/describe/' + tutorial.id"
                        ><i class="material-icons">mode_edit</i>Edit</a
                      >
                    </li>
                    <li>
                      <a
                        v-bind:data-link="tutorialViewLink(tutorial.id)"
                        v-on:click="copyEmbed"
                      >
                        <i
                          v-bind:data-link="tutorialViewLink(tutorial.id)"
                          class="material-icons"
                          >code</i
                        >Copy embed code
                      </a>
                    </li>
                    <li>
                      <a
                        v-bind:data-link="
                          'https://' + host + '/s/' + tutorial.id
                        "
                        v-on:click="copyLink"
                      >
                        <i class="material-icons">insert_link</i>Copy link
                      </a>
                    </li>
                    <li class="divider" tabindex="-1"></li>

                    <li>
                      <a
                        v-bind:data-id="tutorial.id"
                        v-bind:data-title="tutorial.title?tutorial.title.replace(/_/g, ' '):''"
                        v-on:click="deleteConfirm"
                        ><i class="material-icons">delete</i>Delete</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col s1 right-align">
                  <a
                    class="dropdown-trigger"
                    href="#"
                    v-bind:data-target="'ud_uncat_' + index"
                    v-bind:data-link="
                      'https://dashboard.fyiio.com/viewemb.html#tutorial/' +
                      tutorial.id
                    "
                    v-on:click="prepCopy"
                  >
                    <i
                      class="material-icons"
                      v-bind:data-link="
                        'https://dashboard.fyiio.com/viewemb.html#tutorial/' +
                        tutorial.id
                      "
                      >more_vert</i
                    >
                  </a>
                </div>
              </li>
            </ul>
          </div>
          <div
            v-for="(value, propertyName, a_index) in tutorialsByCategory"
            :key="a_index"
          >
            <a :href="'/categories/build/' + value[0]['id']">
              <i
                class="material-icons small right"
                style="padding-right: 20px; font-size: 20px"
                >edit</i
              ></a
            >
            <h3 class="category-header">
              <a :href="'/categories/build/' + value[0]['id']">
                {{ propertyName }}</a
              >
            </h3>
            <ul class="collection s12">
              <li
                class="collection-item row valign-wrapper"
                v-for="(tutorial, index) in value"
                :key="a_index + '-' + index"
              >
                <div class="col s11">
                  <a
                    class="tutorial-link"
                    v-bind:href="tutorialViewLink(tutorial.tutorial_id)"
                    target="_blank"
                    >{{ tutorial["tutorial_title"] }}</a
                  >
                  <ul
                    v-bind:id="'ed_' + a_index + '_' + index"
                    class="dropdown-content"
                  >
                    <li>
                      <a
                        v-bind:href="
                          '/tutorials/describe/' + tutorial.tutorial_id
                        "
                        ><i class="material-icons">mode_edit</i>Edit</a
                      >
                    </li>
                    <li>
                      <a
                        v-bind:data-link="tutorialViewLink(tutorial.tutorial_id)"
                        v-on:click="copyEmbed"
                      >
                        <i
                          v-bind:data-link="tutorialViewLink(tutorial.tutorial_id)"
                          class="material-icons"
                          >code</i
                        >Copy embed code
                      </a>
                    </li>
                    <li>
                      <a
                        v-bind:data-link="'https://' + host + '/s/' + tutorial.tutorial_id"
                        v-on:click="copyLink"
                      >
                        <i class="material-icons">insert_link</i>Copy link
                      </a>
                    </li>
                    <li class="divider" tabindex="-1"></li>

                    <li>
                      <a
                        v-bind:data-id="tutorial.tutorial_id"
                        v-bind:data-idx="index"
                        v-bind:data-title="tutorial.title?tutorial.title.replace(/_/g, ' '): ''"
                        v-on:click="deleteConfirm"
                        ><i class="material-icons">delete</i>Delete</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="col s1 right-align">
                  <a
                    class="dropdown-trigger"
                    href="#"
                    v-bind:data-target="'ed_' + a_index + '_' + index"
                    v-bind:data-link="
                      'https://dashboard.fyiio.com/viewemb.html#tutorial/' +
                      tutorial.tutorial_id
                    "
                    v-on:click="prepCopy"
                  >
                    <i
                      class="material-icons"
                      v-bind:data-link="
                        'https://dashboard.fyiio.com/viewemb.html#tutorial/' +
                        tutorial.tutorial_id
                      "
                      >more_vert</i
                    >
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <!--
        <div id="allTutorials" class="col s12">
          <div
            v-for="(article, a_index) in articles"
            :key="a_index"
            class="row"
          >
            <div v-if="article.chapters && article.chapters.length > 0">
              <ul class="collection s12">
                <li
                  v-for="(item, index) in article.chapters"
                  :key="a_index + '-' + index"
                  class="collection-item row valign-wrapper"
                >
                  <div class="col s11">
                    <div>
                      <a
                        class="tutorial-link"
                        v-bind:href="tutorialViewLink(item.id)"
                        target="_blank"
                        >{{ item.title.replace(/_/g, " ") }}</a
                      >
                    </div>
                    <span class="author">{{
                      item.chapter_author_fullname
                    }}</span>
                    <br /><span class="author"
                      >Categories:
                      <span
                        v-for="(category, index) in tutorialCategories[item.id]"
                        :key="item.id + '_' + index"
                      >
                        <span v-if="index > 0"> | </span>
                        <a
                          style="color: blue"
                          :href="'/categories/build/' + category.id"
                          >{{ category.title }}</a
                        >
                      </span>
                    </span>
                    <ul
                      v-bind:id="'dd_' + a_index + '_' + index"
                      class="dropdown-content"
                    >
                      <li>
                        <a v-bind:href="'/tutorials/describe/' + item.id"
                          ><i class="material-icons">mode_edit</i>Edit</a
                        >
                      </li>
                      <li>
                        <a
                          v-bind:data-link="tutorialViewLink(item.id)"
                          v-on:click="copyEmbed"
                        >
                          <i
                            v-bind:data-link="tutorialViewLink(item.id)"
                            class="material-icons"
                            >code</i
                          >Copy embed code
                        </a>
                      </li>
                      <li>
                        <a
                          v-bind:data-link="'https://' + host + '/s/' + item.id"
                          v-on:click="copyLink"
                        >
                          <i class="material-icons">insert_link</i>Copy link
                        </a>
                      </li>
                      <li class="divider" tabindex="-1"></li>

                      <li>
                        <a
                          v-bind:data-id="item.id"
                          v-bind:data-title="item.title.replace(/_/g, ' ')"
                          v-on:click="deleteConfirm"
                          ><i class="material-icons">delete</i>Delete</a
                        >
                      </li>
                    </ul>
                  </div>
                  <div class="col s1 right-align">
                    <a
                      class="dropdown-trigger"
                      href="#"
                      v-bind:data-target="'dd_' + a_index + '_' + index"
                      v-bind:data-link="
                        'https://dashboard.fyiio.com/viewemb.html#tutorial/' +
                        item.id
                      "
                      v-on:click="prepCopy"
                    >
                      <i
                        class="material-icons"
                        v-bind:data-link="
                          'https://dashboard.fyiio.com/viewemb.html#tutorial/' +
                          item.id
                        "
                        >more_vert</i
                      >
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div id="copyAreaWrapper">
            <textarea id="copyArea" v-model="textToCopy"></textarea>
            <textarea id="copyLink"></textarea>
            <textarea id="copyEmbedLink"></textarea>
          </div>
          
        </div> -->
         <div id="copyAreaWrapper">
            <textarea id="copyArea" v-model="textToCopy"></textarea>
            <textarea id="copyLink"></textarea>
            <textarea id="copyEmbedLink"></textarea>
          </div>
      </div>
    </div>
    <div id="deleteModal" class="delete-modal modal">
      <div class="modal-content">
        <h5>Are you sure you want to delete this tutorial?</h5>
        <p>{{ deleteTitle }}</p>
      </div>
      <div class="modal-footer">
        <a class="modal-action modal-close waves-effect waves-grey btn-flat"
          >Cancel</a
        >
        <!-- <a href="#!" class="modal-action modal-close waves-effect waves-grey btn-flat red-text">Coming Soon!</a> -->
        <a
          v-on:click="deleteTutorial"
          class="modal-action modal-close waves-effect waves-red red-text btn-flat"
          >Delete</a
        >
      </div>
    </div>
    <div id="embedModal" class="embed-modal modal modal-fixed-footer">
      <div class="modal-content">
        <textarea id="embedCode"></textarea>
        <h2 class="center-align select-embed">Select preferred embed style</h2>
        <div class="row">
          <div class="col s4" v-on:click="verticalEmbed">
            <div class="card">
              <div class="grey center-align play">
                <i class="material-icons">play_arrow</i>
              </div>
              <div class="bordered">
                <div class="grey">&nbsp;</div>
              </div>
              <div class="grey">&nbsp;</div>
              <div class="grey">&nbsp;</div>
              <p class="center-align">vertical</p>
            </div>
            <p class="left-align grey-text">
              recommended for most locations
              <br />
              use in areas less than 1,000px wide
            </p>
          </div>
          <div class="col s8" v-on:click="horizontalEmbed">
            <div class="card">
              <div class="row">
                <div class="col s6">
                  <div class="grey center-align play">
                    <i class="material-icons">play_arrow</i>
                  </div>
                  <div class="dashed">
                    <div class="col s2 valign-wrapper timer">
                      <i class="material-icons text-grey">timer</i>
                    </div>
                    <div class="col s10">
                      <div class="grey">&nbsp;</div>
                      <div class="grey">&nbsp;</div>
                    </div>
                  </div>
                </div>
                <div class="col s6">
                  <div class="bordered" style="height: 100px">
                    <div class="grey">&nbsp;</div>
                  </div>
                  <div class="grey">&nbsp;</div>
                  <div class="grey">&nbsp;</div>
                </div>
              </div>
              <p class="center-align">horizontal</p>
            </div>
            <p class="left-align grey-text">
              best for locations over 1,000px wide
              <br />
              will automatically convert to vertical layout if embeddable area
              is under 1,000px wide and/or viewed on a mobile device
            </p>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <a class="modal-action modal-close waves-effect waves-green btn-flat"
          >Cancel</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import featureGate from '@/mixins/featureGate'
import HelpSidebar from "@/components/HelpSidebar";
import Sidebar from "@/components/Sidebar";
import cognitoAuth from "@/plugins/cognito";
import GqlQuery from "@/plugins/gql";
import GqlQueryV2 from "@/plugins/gqlV2";

export default {
  mixins: [featureGate],
  mounted() {
    var self = this;
    M.AutoInit();
    cognitoAuth.getIdToken(function (err, jwttoken) {
      self.token = jwttoken;
    });
    cognitoAuth.getUserAttributes(function (err, user_attributes) {
      self.organization_id = user_attributes["custom:organization_id"];
      self.user_id = user_attributes["email"];
    });

    GqlQuery.getArticles(function (err, response) {
      if (err) {
        self.error = err;
      }
      response.then(function (val) {
        self.articles = val.data.articles;
        self.categoriesForTutorials();
        self.checkGrandfatheredTutorials(self.articles);
        self.loading = false;
        M.AutoInit();
      });
    });
  },
  updated() {
    M.AutoInit();
  },
  name: "Tutorials",
  data() {
    return {
      token: "",
      articles: [],
      tutorialCategories: {},
      tutorialsByCategory: {},
      uncategorizedTutorials: [],
      textToCopy: "",
      embedLink: "",
      error: "",
      deleteId: "",
      deleteTitle: "",
      loading: true,
      host: window.location.host,
      helpSidebarOpen: false,
      tutorialSelected: false
    };
  },

  components: {
    HelpSidebar,
    Sidebar,
    cognitoAuth,
  },
  methods: {
    helpClick() {
      if (this.helpSidebarOpen) {
        this.tutorialSelected = false;
        $("#app").removeClass("sidebarOpen");
      } else {
        $("#app").addClass("sidebarOpen");
      }
      this.helpSidebarOpen = !this.helpSidebarOpen;
    },
    selectTutorial(tutorial) {
      this.tutorialSelected = tutorial;
    },
    tutorialViewLink(id) {
      return `https://${window.location.host}/s/${id}`;
    },
    categoriesForTutorials() {
      var self = this;
      GqlQueryV2.getCategoriesForTutorials(function (err, response) {
        if (err) {
          self.error = err;
        }
        //self.tutorialsByCategory=response.data.tutorials_by_category;
        let holdCategories = response.data.tutorials_by_category;
        holdCategories.forEach((category) => {
          if (self.tutorialsByCategory[category.title]) {
            self.tutorialsByCategory[category.title].push(category);
          } else {
            self.tutorialsByCategory[category.title] = [category];
          }
        });
        holdCategories.forEach((category) => {
          if (self.tutorialCategories == undefined) {
            self.tutorialCategories = {};
          }
          if (self.tutorialCategories[category.tutorial_id]) {
            self.tutorialCategories[category.tutorial_id].push(category);
          } else {
            self.tutorialCategories[category.tutorial_id] = [category];
          }
        });
        //find uncategorized tutorials
        self.articles.forEach((article) => {
          article.chapters.forEach((chapter) => {
            if (self.tutorialCategories[chapter.id] == undefined) {
              self.uncategorizedTutorials.push(chapter);
            }
          });
        });

        self.$forceUpdate();
      });
    },
    loadArticles() {
      var self = this;
      GqlQuery.getArticles(function (err, response) {
        if (err) {
          self.error = err;
        }
        response.then(function (val) {
          self.articles = val.data.articles;
          M.AutoInit();
          self.$forceUpdate()
        });
      });
    },

    deleteConfirm(event) {
      this.deleteId = event.target.getAttribute("data-id");
      this.deleteTitle = event.target.getAttribute("data-title");
      var options = {};
      var elem = document.querySelector(".delete-modal");

      // allow time for dom to react to data change
      setTimeout(function () {
        var instance = M.Modal.init(elem, options);
        instance.open();
      }, 10);
    },
    createTutorial() {
      var self = this;
      // window.location="/tutorial.html#tutorialnew/" + self.articles[0].id;
      window.location = "/tutorials/new/" + self.articles[0].id;
    },
    deleteTutorial() {
      var self = this;
      GqlQuery.deleteTutorial(this.deleteId, function (err, response) {
        if (err) {
          M.toast({ html: "Error deleting tutorial, please try again" }, 4000);
        } else {
          if (response["errors"]) {
            M.toast(
              { html: "Error deleting tutorial, please try again" },
              4000
            );
          } else {
            M.toast({ html: "Successfully deleted tutorial!" }, 4000);
            
            let categoriesToClean = self.tutorialCategories[self.deleteId];
            if(categoriesToClean==undefined){
              self.loadArticles();
              return;
            }
            categoriesToClean.forEach((category) => {
              GqlQueryV2.getCategory(category.id, function (err, response) {
                let hold = response.data;
                if (hold != undefined && hold.category.length > 0) {
                  let catcontent = hold.category[0].content;
                  catcontent.forEach((contenter, idx) => {
                    if (contenter["id"] == self.deleteId) {
                      let variables = {};
                      variables.id = category.id;
                      variables.idx = idx;
                      GqlQueryV2.updateCategoryMembership(
                        variables,
                        (err, result) => {
                          if (err) {
                            this.error = err;
                            M.toast({
                              html:
                                "There was an error updating your quiz, please try again or contact Fyiio support",
                              inDuration: 300,
                            });
                          } 
                        }
                      );
                    }
                  });
                }
              });
              self.loadArticles()
            });
          }
        }
      });
    },

    prepCopy(event) {
      console.log("event", event);
      var link = event.target.getAttribute("data-link");
      document.getElementById("copyLink").value = link;
    },
    copyLink(event) {
      console.log(event.target.getAttribute("data-link"));
      var link = event.target.getAttribute("data-link");
      this.copyText(link);
    },
    copyText(text) {
      this.textToCopy = text;
      var self = this;
      document.getElementById("copyArea").value = text;
      document.getElementById("copyArea").select();
      document.execCommand("copy");
      M.toast({ html: "Tutorial URL copied to clipboard!" }, 4000);
      document.querySelector("body").style.overflow = "";
    },
    copyEmbedCode(code) {
      document.getElementById("embedCode").value = code;
      document.getElementById("embedCode").select();
      document.execCommand("copy");
      M.toast({ html: "Code copied to clipboard!" }, 4000);
      document.querySelector("body").style.overflow = "";
    },

    verticalEmbed() {
      var code =
        '<iframe src="' +
        document.getElementById("copyLink").value +
        '" width="600" height="800" frameborder="0" allowfullscreen="allowfullscreen"></iframe>';
      this.copyEmbedCode(code);
    },
    horizontalEmbed() {
      var code =
        '<iframe src="' +
        document.getElementById("copyLink").value +
        '" width="100%" height="800" frameborder="0" allowfullscreen="allowfullscreen"></iframe>';
      this.copyEmbedCode(code);
    },
    copyEmbed(event) {
      this.prepCopy(event);
      this.embedLink = event.target.getAttribute("data-link");
      var options = {};
      var elem = document.querySelector(".embed-modal");
      var instance = M.Modal.init(elem, options);
      instance.open();
    },
  },
};
</script>


<style scoped>
ul.collection {
  overflow: visible;
  border: none;
}
.dropdown-content {
  min-height: 200px;
  min-width: 200px;
}
.token {
  word-break: break-all;
}
#copyAreaWrapper,
#embedCode {
  position: absolute;
  left: -1000px;
}
#embedModal {
  width: 773px;
  height: 525px;
  max-height: 525px;
  font-size: 12px !important;
}
#embedModal .play i {
  padding: 40px;
  color: white;
  font-size: 50px;
  margin: 0 auto;
}
#embedModal h2 {
  font-size: 24px;
}
#embedModal .card {
  padding: 10px;
  cursor: pointer;
}
#embedModal div {
  margin-bottom: 10px;
}
#embedModal .bordered {
  border: 1px solid grey;
  height: 75px;
}
#embedModal .dashed {
  border: 1px dashed grey;
  height: 75px;
  padding: 10px;
}
.timer {
  height: 100%;
  color: grey;
  padding: 0;
}
.tutorial-link {
  color: rgba(0, 0, 0, 0.87);
}
.gray-fab {
  background-color: #58595b;
}

.help-logo {
  margin-top: 44px;
  top: 44px;
  width: 100px;
  height: 100px;
  border-radius: 100px;
  border: 4px solid #58595b;
  text-align: center;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.help-logo img {
  height: 27px;
  width: 50px;
}
#helpSidebar {
  
  position: absolute;
  right: -400px;
  width: 375px;
  min-height: calc(100vh - 65px);
  top:0px;
  z-index: 1000;
  background: white;
  transition: all 0.25s ease-in;
}
#helpSidebar.open {
  right: 0;
}
.help {
  cursor: pointer;
  display:inline-block;
  float: right;
  padding-right:50px;
  padding-top:5px;

}
iframe {
  height: calc(100vh );
}
.tutorial-wrap {
  margin-top: -24px;
}
</style>



// WEBPACK FOOTER //
// src/containers/dashboard/Tutorials.vue